export const filterTree = <T extends { id: string; name: string; children: T[] }>(
  arr: T[],
  searchValue: string,
): { filteredItems: T[]; expandedKeys: string[] } => {
  if (!searchValue) return { filteredItems: arr, expandedKeys: [] };

  const clonedTree = structuredClone(arr);
  const expandedKeys: string[] = [];

  const lowerCaseSearchValue = searchValue.toLowerCase();

  const filterNode = (item: T) => {
    const isSearchValueMatched = item.name?.toLowerCase().includes(lowerCaseSearchValue);
    expandedKeys.push(item.id);

    if (isSearchValueMatched) return true;

    if (item.children) {
      item.children = item.children.filter(filterNode);
      return item.children.length > 0;
    }

    return false;
  };

  return { filteredItems: clonedTree.filter(filterNode), expandedKeys: expandedKeys };
};
